var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/visual_character_counter.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { length } from 'stringz';
import ProgressCircle from 'soapbox/components/progress_circle';
const messages = defineMessages({
  title: {
    "id": "compose.character_counter.title",
    "defaultMessage": "Used {chars} out of {maxChars} characters"
  }
});
/** Renders a character counter */
const VisualCharacterCounter = ({
  text,
  max
}) => {
  const intl = useIntl();
  const textLength = length(text);
  const progress = textLength / max;
  return /*#__PURE__*/React.createElement(ProgressCircle, {
    title: intl.formatMessage(messages.title, {
      chars: textLength,
      maxChars: max
    }),
    progress: progress,
    radius: 10,
    stroke: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  });
};
export default VisualCharacterCounter;